import { Outlet } from "react-router";
import { Navbar } from "../Navigation/Navbar";
import { Footer } from "../Navigation/Footer";

export const PublicLayout = () => (
  <div className="max-w-[2000px] mx-auto">
    <Navbar />
    <main>
      <Outlet />
    </main>
    <Footer />
  </div>
);
